module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic02.486ee27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic02.png
// module id = 502
// module chunks = 1